import type { filterFactory } from "@similarweb/pro-logic-components";

import { translate } from "app/filters/i18nFilter";
import { MENTION_WIN_STATUS } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/prompts-report/prompts-widget/consts";
import { TopicSourceType } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/components/source-badge/types";
import { getSentimentStatusConfig } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMConsts";
import {
    CitationGapStatus,
    CitationStatus,
    SentimentStatus,
    VolatilityStatus,
} from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

type MultiSelectOption = filterFactory.MultiSelectOption;

const MENTION_FILTER_STATUS = {
    Mentioned: MENTION_WIN_STATUS,
    NotMentioned: SentimentStatus.NotMentioned,
} as const;

export const MENTION_STATUS_OPTIONS: MultiSelectOption[] = Object.values(MENTION_FILTER_STATUS).map((value) => ({
    id: value,
    value,
    label: translate(`llm.prompts.filters.mention_status.${value.replace(/\s+/g, "_")}`),
}));

const sentimentStatusConfig = getSentimentStatusConfig();
export const SENTIMENT_TONE_OPTIONS: MultiSelectOption[] = Object.values(SentimentStatus)
    .filter((status) => status !== SentimentStatus.NotMentioned)
    .map((status) => ({
        id: status,
        value: status,
        label: sentimentStatusConfig[status].text ?? status,
    }));

export const LATEST_CITATION_STATUS_OPTIONS: MultiSelectOption[] = Object.values(CitationStatus).map((status) => ({
    id: status,
    value: status,
    label: status,
}));

export const CITATION_GAP_OPTIONS: MultiSelectOption[] = Object.values(CitationGapStatus).map((status) => ({
    id: status,
    value: status,
    label: status,
}));

export const CITATION_VOLATILITY_OPTIONS: MultiSelectOption[] = Object.values(VolatilityStatus).map((status) => ({
    id: status,
    value: status,
    label: status,
}));

export const TOP_SOURCE_CATEGORY_OPTIONS: MultiSelectOption[] = Object.values(TopicSourceType).map((category) => ({
    id: category,
    value: category,
    label: category,
}));
